import { Controller } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import styled from 'styled-components'
import { MonthYearPicker } from './MonthYearPicker'

const MonthYearFieldWrap = styled(Form.Field)`
    width: 100%;
`

export const FormMonthYearField = ({
    control,
    monthName = 'ScheduleMonth',
    yearName = 'ScheduleYear',
    label = 'Month & Year',
    errors,
    onChange,
}) => (
    <MonthYearFieldWrap
        error={!!errors?.ScheduleMonth || !!errors?.ScheduleYear}
    >
        <Controller
            control={control}
            name={monthName}
            render={({ field: monthField }) => (
                <Controller
                    control={control}
                    name={yearName}
                    render={({ field: yearField }) => (
                        <MonthYearPicker
                            label={label}
                            month={monthField.value}
                            year={yearField.value}
                            onChange={(nextMonth, nextYear) => {
                                monthField.onChange(nextMonth)
                                yearField.onChange(nextYear)
                                onChange?.(nextMonth, nextYear)
                            }}
                        />
                    )}
                />
            )}
        />
        {(errors?.ScheduleMonth || errors?.ScheduleYear) && (
            <p
                className="error"
                style={{ color: 'red', margin: '4px 0 0', fontSize: '0.75em' }}
            >
                {errors?.ScheduleMonth?.message ||
                    errors?.ScheduleYear?.message}
            </p>
        )}
    </MonthYearFieldWrap>
)
